import React from "react";
import { UsageOverview } from "@/components/pages/billing/UsageOverview";
import { ChargeHistory } from "@/components/pages/billing/ChargeHistory";

export function UsageTab() {
  return (
    <div>
      <UsageOverview />
      <ChargeHistory />
    </div>
  );
}
